import React from 'react';

import './AuLinkList.scss';

interface IAuLinkListItem {
  text: string | React.ReactNode;
  link?: string;
}

/**
 * An item inside the AUlinkList component
 *
 * @param  {node}   text             - The link Text or link html
 * @param  {string} link             - The link URL, optional
 * @returns {React.FC} returns AuLinkListitem used for Breadcrumbs
 */
export const AuLinkListItem: React.FC<IAuLinkListItem> = ({ text, link }) => {
  if (!link) {
    return <li>{text}</li>;
  }
  return <li><a href={link}>{text}</a></li>;
};

interface IAuLinkList {
  items: Array<IAuLinkListItem>;
  className?: string;
  inline?: boolean;
  style?: React.CSSProperties;
}

/**
 * DEFAULT
 * The Link List component
 * An item inside the AUlinkList component
 *
 * @param  {object} onClick          - The onClick event handler
 * @param  {object} attributeOptions - Any other attribute options, optional
 * @returns {React.FC} returns AuLinkListitem used for Breadcrumbs
 */
const AuLinkList: React.FC<IAuLinkList> = ({ inline, items, className = '', ...attributeOptions }) => (
  <ul className={`au-link-list ${className}${inline ? ' au-link-list--inline' : ''}`} {...attributeOptions}>
    {
      items.map(
        (item, i) => <AuLinkListItem key={i} {...item} />
      )
    }
  </ul>
);

export default AuLinkList;
